import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unread",
  "use": "icon-unread-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unread\"><path d=\"M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16Zm0 3.096-6.606 6.419-.127.113a2 2 0 0 1-2.66-.113L4 7.097V18h16V7.096ZM18.258 6H5.741L12 12.08 18.258 6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol